<span class="attachment-wrapper">
    <img src="/images/icons/forms/check.svg" class="attached-file-icon" />
    <span class="attachment-filename" spTooltip [tooltipText]="selectedFileName">{{
        selectedFileName
    }}</span>
    <span class="attached-file-size">[{{ fileSizeLabel }}]</span>
    <a *ngIf="removable" class="remove-attachment" (click)="removeAttachment()">Remove</a>
</span>
